const steps = [
  {
    step: "01",
    title: "Start Your Application Online",
    description:
      "Complete our secure online application in 10 minutes. We will ask about your travel dates, passport type, and current document status. No appointment needed — start any time, day or night.",
    icon: "ri-computer-line",
  },
  {
    step: "02",
    title: "Document Review &amp; Guidance",
    description:
      "Our team reviews your application, photos, and supporting documents before submission. We catch errors that would delay processing — wrong photo dimensions, missing signatures, incorrect forms. This pre-check alone saves most travelers 1–2 weeks.",
    icon: "ri-file-search-line",
  },
  {
    step: "03",
    title: "Secure Document Pickup",
    description:
      "For Marco Island residents, we arrange secure document pickup via our courier network or provide prepaid overnight shipping labels. Your documents are tracked at every step, with insurance coverage and signature confirmation — whether you are at your waterfront home or on your boat at the marina.",
    icon: "ri-truck-line",
  },
  {
    step: "04",
    title: "Expedited Processing",
    description:
      "Your application enters our registered courier channel with the U.S. State Department. Emergency applications move through same-day or next-day review. Rush applications receive priority handling within 4–7 business days. Tournament departures and villa rental deadlines are treated with the urgency they deserve.",
    icon: "ri-flashlight-line",
  },
  {
    step: "05",
    title: "Passport Delivered to Your Door",
    description:
      "Your new passport ships via secure overnight delivery to your Marco Island address or dock. We notify you the moment it ships, with tracking information and delivery confirmation. Most Marco Island clients receive their passports 24 hours to 2 weeks after starting, depending on the service level selected.",
    icon: "ri-mail-send-line",
  },
];

export default function MarcoIslandHowItWorksSection() {
  return (
    <section id="how-it-works" className="py-16 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <span className="inline-block text-[#B22222] text-xs font-bold uppercase tracking-[0.15em] mb-3">
            The Process
          </span>
          <h2 className="font-serif text-2xl md:text-4xl font-bold text-[#1A365D] mb-4">
            How Fast Passport Center Works
          </h2>
          <p className="text-gray-600 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
            A simple, five-step process designed to eliminate stress and get your passport in hand as quickly as possible.
          </p>
        </div>

        <div className="grid md:grid-cols-5 gap-4 lg:gap-6">
          {steps.map((s, i) => (
            <div key={i} className="relative">
              <div className="bg-[#F8F9FB] rounded-lg p-6 h-full border border-gray-100 hover:border-[#F6C344]/50 transition-all">
                <div className="text-[#F6C344] font-bold text-3xl font-serif mb-3">{s.step}</div>
                <div className="w-10 h-10 rounded-lg bg-[#1A365D] flex items-center justify-center mb-4">
                  <i className={`${s.icon} text-[#F6C344] text-lg`}></i>
                </div>
                <h3 className="font-serif text-base font-bold text-[#1A365D] mb-2">{s.title}</h3>
                <p className="text-gray-600 text-xs leading-relaxed">{s.description}</p>
              </div>
              {i < steps.length - 1 && (
                <div className="hidden md:block absolute top-1/2 -right-3 z-10">
                  <i className="ri-arrow-right-line text-[#F6C344] text-xl"></i>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <a
            href="https://fastpassportcenter.com/checkout/"
            className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-8 py-3 rounded-md transition-all hover:scale-105 whitespace-nowrap"
          >
            Start Your Application <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}